import state from '@/store/module_principal/state'
import mutations from '@/store/module_principal/mutations'
import actions from '@/store/module_principal/actions'

export default ({
  state,
  mutations,
  actions,
})